import { Component, OnInit } from '@angular/core';
import { PublicService } from 'src/app/servicios/public/public.service';
import { ActivatedRoute } from '@angular/router';
import { ServiceService } from 'src/app/servicios/service.service';
import { TreeModel, NodeMenuItemAction } from 'ng2-tree';
import { DebugRenderer2 } from '@angular/core/src/view/services';


declare var $: any;

@Component({
  selector: 'app-preliminar',
  templateUrl: './preliminar.component.html',
  styleUrls: ['./preliminar.component.css']
})
export class PreliminarComponent implements OnInit {

  public id: number;
  public norma: any = [];
  public tipo: boolean;
  public rutaArchivo: string;
  public titulo: string;
  public serve: any;
  public detalleTraza: any = {};

  public tree: TreeModel;

 //private form: FormBuilder, private route: Router
  constructor(private publicServi: PublicService, private router: ActivatedRoute, private servi: ServiceService) { 
    
    this.router.params.subscribe(params => {
      this.id = params['id'];

      this.publicServi.getDetalle(this.id).subscribe(data => {
        if (data['success']) {
          this.norma = data['data']['norma'];
          this.tipo = data['tipo'];
          
          let traza = data['data']['traza'];
          let children = [];
          for (let i = 0; i < traza.length; i++) {

            var dt = {
              value: '<span title="' + traza[i]['nombre']+'" ><b>' + traza[i]['accion'] + ':</b> ' + traza[i]['nombre'] +'</span>',
              children: [
                {
                  value: '<a class="btn btn-link" role="button" title="Ver documento" data-verdocumento="true" data-nombre="' + traza[i]["nombre"] +'" data-ruta="' + traza[i]["doc_ruta"]+'" ><i class="far fa-file"></i> Ver documento </a>' },
                {
                  value: '<a class="btn btn-link" role="button" title="Ver detalle" data-detalletraza=\''+ JSON.stringify(traza[i]) +'\'  ><i class="far fa-file"></i> Ver detalle</a>'
                },
              ]
            };

            children.push(dt);

          } 
          if(traza.length >0){
            this.tree  = {
              settings: {
                static: true,
                rightMenu: true,
                leftMenu: true,
                cssClasses: {
                  expanded: 'fas fa-folder-open style-folder',
                  collapsed: 'fas fa-folder-plus style-folder',
                  leaf: 'fa fa-lg',
                  empty: 'fa fa-caret-right disabled'
                },
                templates: {
                  node: '<i class="fa fa-folder-o fa-lg"></i>',
                  leaf: '<i class="fa fa-file-o fa-lg"></i>',
                  leftMenu: '<i class="fa fa-navicon fa-lg"></i>'
                },
                menuItems: [
                  { action: NodeMenuItemAction.Custom, name: 'Foo', cssClass: 'fa fa-arrow-right' },
                  { action: NodeMenuItemAction.Custom, name: 'Bar', cssClass: 'fa fa-arrow-right' },
                  { action: NodeMenuItemAction.Custom, name: 'Baz', cssClass: 'fa fa-arrow-right' }
                ]
              },

              value: '<h3 class="mt-0" > Concordancia </h3>',
              children: children
            };
          }

        }
      });


    });

    this.serve = this.publicServi.getServe();
  }

  ngOnInit() {
  }

  openModalArchivo(ruta, nombre) {
    this.rutaArchivo = ruta;
    this.titulo = nombre;
    $('#ModalVerArchivo').modal("show");
  }



  clickInNode(e){
    var ele = $(e.node.value);
   
    if ( ele.data("verdocumento") ){
      this.openModalArchivo(ele.data("ruta"), ele.data("nombre"));
    }
    else if (ele.data("detalletraza")) {
      this.detalleTraza = ele.data("detalletraza");
      $('#ModalVerTraza').modal("show");
    }

  }

}

